import { CreateFormData } from "@/components/create/types";

// Helper function to calculate hasPrompt based on current form data
export function calculateHasPrompt(formData: CreateFormData): boolean {
  // hasPrompt should be true if:
  // 1. There's a valid front text prompt (10+ characters), OR
  // 2. Front is upload preset with uploaded front image, OR
  // 3. There's a valid back text prompt (10+ characters), OR
  // 4. Back is upload preset with uploaded back image
  const hasValidFrontPrompt = formData.prompt.trim().length >= 10;
  const hasValidBackPrompt =
    formData.backPrompt && formData.backPrompt.trim().length >= 10;
  const hasFrontUploadedImage = !!(
    (formData.uploadedFrontImages && formData.uploadedFrontImages.length > 0) ||
    (formData.uploadedFrontImageUrls &&
      formData.uploadedFrontImageUrls.length > 0)
  );
  const hasBackUploadedImage = !!(
    (formData.uploadedBackImages && formData.uploadedBackImages.length > 0) ||
    (formData.uploadedBackImageUrls &&
      formData.uploadedBackImageUrls.length > 0)
  );
  const isFrontUploadPreset = !!formData.isFrontUploadPreset;
  const isBackUploadPreset = !!formData.isBackUploadPreset;

  const frontReady =
    hasValidFrontPrompt || (isFrontUploadPreset && hasFrontUploadedImage);
  const backReady =
    hasValidBackPrompt || (isBackUploadPreset && hasBackUploadedImage);

  return frontReady || backReady;
}
